export default __webpack_public_path__ + "static/media/document-blue.c859dcdd.svg";